import useCopyUrlToClipboard from '@/pages/CompanyReport/hooks/useCopyUrlToClipboard';
import CopyLinkOutline from '@simplywallst/ui-core/icons/CopyLinkOutline';

export const ShareNarrative = () => {
  const copyUrlToClipboard = useCopyUrlToClipboard();

  return (
    <div
      onClick={copyUrlToClipboard}
      className="flex cursor-pointer items-center gap-2"
      role="button"
    >
      <div className="flex items-center gap-1">
        <div className="flex items-center">
          <CopyLinkOutline
            aria-label="Share"
            className="size-4 fill-softer lg:size-5"
          />
        </div>
        <span className="text-tiny text-solid">Share</span>
      </div>
    </div>
  );
};
